<template>
  <Modal
    :id="'cmp-royalty-contracts-sidewindow-scale_types_form'"
    @cancelled="onCancel"
  >
    <template slot="header">{{ $dft.snakeCaseToWords("scales") }}</template>

    <template slot="options">
      <button class="dt-button v1 s6" @click.stop="onScaleQty">
        Scale by QTY
      </button>
      <button class="dt-button v1 s6" @click.stop="onScaleTurnover">
        Scale by Turnover
      </button>
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";

export default {
  components: {
    Modal
  },
  props: ["selectedContractDetails"],
  computed: {
    contract_id: function() {
      return this.$route.params.contract_id;
    }
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },

    onScaleQty: function() {
      this.$emit("selected_qty", true);
    },
    onScaleTurnover: function() {
      this.$emit("selected_turnover", true);
    }
  }
};
</script>
